import { lazy } from "react";
import Loadable from "src/routes/Loadable";

const TrainingVideos = Loadable(
  lazy(() => import("src/pages/admin/training"))
);

const training = [
  {
    path: "training",
    children: [
      { path: "videos", element: <TrainingVideos /> },
    ],
  },
];

export default training;
